import "./Checkout.css";
import shipping1 from "../assets/shipping-1.png";
import shipping2 from "../assets/shipping-2.png";
import shipping3 from "../assets/shipping-3.png";
import shipping4 from "../assets/shipping-4.png";
import creditCards from "../assets/credit-cards.png";
import mercadopago from "../assets/mercadopago.png";
import paypal from "../assets/paypal.webp";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { resetCartList } from "../redux/cartListSlice";
import secure from "./imagessecure.png";
import { toast } from "react-toastify";

const notify = () => {
  toast.info(
    "This was added only for design purposes, no functionalities included.",
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
};

function Checkout() {
  const [order, setOrder] = React.useState({});
  const [showPaypal, setShowPaypal] = React.useState(false);
  const [showCreditCard, setShowCreditCard] = React.useState(false);
  const [showMercadoPago, setShowMercadoPago] = React.useState(false);
  const [paymentCompleted, setPaymentCompleted] = React.useState(false);
  const token = useSelector((state) => {
    return state.token;
  });
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cartList);
  const dispatch = useDispatch();
  const [orderTotal, setOrderTotal] = React.useState(0);

  const tokenBearer = token.token;
  const orderNumber = useSelector((state) => {
    return state.orderNumber;
  });

  useEffect(() => {
    const getOrder = async () => {
      try {
        const authAxios = axios.create({
          headers: {
            Authorization: `Bearer ${tokenBearer}`,
            ContentType: `application/json`,
          },
        });
        const response = await authAxios.get(
          `${process.env.REACT_APP_API_URL}/private/order/${orderNumber}`
        );

        setOrder(response.data.productArray);
        setOrderTotal(response.data.total);
      } catch (err) {
        console.error(err);
      }
    };
    getOrder();
  }, []);

  const handlePayment = async (e, orderId) => {
    e.preventDefault();
    try {
      const authAxios = axios.create({
        headers: {
          Authorization: `Bearer ${tokenBearer}`,
          ContentType: `application/json`,
        },
      });
      const response = await authAxios.post(
        `${process.env.REACT_APP_API_URL}/private/pay/${orderId}`
      );
      dispatch(resetCartList());
      setPaymentCompleted(true);
      navigate("/success");
    } catch (err) {
      console.log(err.data);
    }
  };

  const handleClickPaypal = () => {
    setShowPaypal(!showPaypal);
    setShowCreditCard(false);
    setShowMercadoPago(false);
  };
  const handleClickCreditCard = () => {
    setShowCreditCard(!showCreditCard);
    setShowPaypal(false);
    setShowMercadoPago(false);
  };
  const handleClickMercadoPago = () => {
    setShowMercadoPago(!showMercadoPago);
    setShowPaypal(false);
    setShowCreditCard(false);
  };

  return (
    <div id="checkout-container-fluid" className="container-fluid">
      <div className="container pt-5 pb-5 mb-4">
        <h4 className="text-start  mb-5">Checkout</h4>
        <div className="row">
          <div className="col-lg-8 mb-5 ps-0">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Your Personal Details</Accordion.Header>
                <Accordion.Body>
                  <form className="row g-3 text-start">
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        User Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-end">
                      <input
                        type="text"
                        className="form-control"
                        id="inputPassword4"
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Phone Number"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="inputAddress" className="form-label">
                        Mailing Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputAddress"
                        placeholder="Mailing Address"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="City"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Post Code
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Post Code"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Country
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Country"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputState" className="form-label">
                        Region/State
                      </label>
                      <select id="inputState" className="form-select">
                        <option>Choose...</option>
                        <option>...</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gridCheck"
                        />
                        <label className="form-check-label" htmlFor="gridCheck">
                          My delivery and mailing addresses are the same.
                        </label>
                      </div>
                    </div>
                    <div className="col-12 pb-3">
                      <button
                        onClick={notify}
                        id="next-step-button"
                        type="button"
                        className="btn btn-primary py-2"
                      >
                        Next Step
                      </button>
                    </div>
                  </form>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Shipping Address</Accordion.Header>
                <Accordion.Body>
                  <form className="row g-3 text-start">
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        User Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-end">
                      <input
                        type="text"
                        className="form-control"
                        id="inputPassword4"
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Phone Number"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="inputAddress" className="form-label">
                        Mailing Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputAddress"
                        placeholder="Mailing Address"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="City"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Post Code
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Post Code"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="inputEmail4" className="form-label">
                        Country
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Country"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputState" className="form-label">
                        Region/State
                      </label>
                      <select id="inputState" className="form-select">
                        <option>Choose...</option>
                        <option>...</option>
                      </select>
                    </div>

                    <div className="col-md-12">
                      <div className="checkout-payment-option">
                        <h6 className="heading-6 font-weight-400 payment-title mb-40">
                          Select Delivery Option
                        </h6>
                        <div className="payment-option-wrapper">
                          <div id="shipping-div" className="row">
                            <div className="col-sm-6 col-xl-3">
                              <Link
                                onClick={notify}
                                to="#"
                                className="btn btn-outline-primary text-center text-secondary px-4 py-3"
                                id="shipping-1"
                              >
                                <label htmlFor="shipping-1">
                                  <img src={shipping1} alt="Shipping-1" />
                                  <p className="mb-0">Standard Shipping</p>
                                  <span className="price">$10.50</span>
                                </label>
                              </Link>
                            </div>
                            <div className="col-sm-6 col-xl-3">
                              <Link
                                onClick={notify}
                                to="#"
                                className="btn btn-outline-primary text-secondary text-center px-4 py-3 "
                                id="shipping-2"
                              >
                                <label htmlFor="shipping-2">
                                  <img src={shipping2} alt="Shipping-2" />
                                  <p className="mb-0">Standard Shipping</p>
                                  <span className="price">$10.50</span>
                                </label>
                              </Link>
                            </div>
                            <div className="col-sm-6 col-xl-3">
                              <Link
                                onClick={notify}
                                to="#"
                                className="btn btn-outline-primary text-center text-secondary px-4  py-3"
                                id="shipping-3"
                              >
                                <label htmlFor="shipping-3">
                                  <img src={shipping3} alt="Shipping-3" />
                                  <p className="mb-0">Standard Shipping</p>
                                  <span className="price">$10.50</span>
                                </label>
                              </Link>
                            </div>
                            <div className="col-sm-6 col-xl-3">
                              <Link
                                onClick={notify}
                                to="#"
                                className="btn btn-outline-primary text-secondary text-center px-4 py-3"
                                id="shipping-4"
                              >
                                <label htmlFor="shipping-4">
                                  <img src={shipping4} alt="Shipping-4" />
                                  <p className="mb-0">Standard Shipping</p>
                                  <span className="price">$10.50</span>
                                </label>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-3">
                      <button
                        onClick={notify}
                        id="previous-button"
                        type="button"
                        className="btn btn-primary mt-3 py-2"
                      >
                        Previous
                      </button>
                      <button
                        onClick={notify}
                        id="save-button"
                        type="button"
                        className="btn btn-dark mt-3 ms-2 py-2"
                      >
                        Save & Continue
                      </button>
                    </div>
                  </form>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Payment Info</Accordion.Header>
                <Accordion.Body>
                  <form className="row g-3 text-start">
                    <div className="form-check">
                      <input
                        onClick={handleClickPaypal}
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault2"
                      >
                        Paypal{" "}
                        <img
                          className="paymentSecureLogo mx-2"
                          src={secure}
                          style={{
                            width: `1rem`,
                            height: `1rem`,
                          }}
                        />
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        onClick={handleClickMercadoPago}
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        MercadoPago{" "}
                        <img
                          className="paymentSecureLogo mx-2"
                          src={secure}
                          style={{
                            width: `1rem`,
                            height: `1rem`,
                          }}
                        />
                      </label>
                    </div>
                    <div className="form-check pb-3">
                      <input
                        onClick={handleClickCreditCard}
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        Credit Card{" "}
                        <img
                          className="paymentSecureLogo mx-2"
                          src={secure}
                          style={{
                            width: `1rem`,
                            height: `1rem`,
                          }}
                        />
                      </label>
                    </div>

                    {showCreditCard && (
                      <>
                        <div className="col-12">
                          <label htmlFor="inputAddress" className="form-label">
                            Cardholder Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputAddress"
                            placeholder="Cardholder Name"
                          />
                        </div>
                        <div className="col-12">
                          <label htmlFor="inputAddress" className="form-label">
                            Card Number
                          </label>
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control"
                              id="inputAddress"
                              placeholder="0000 0000 0000 0000"
                            />
                            <div className="position-absolute top-0 end-0">
                              <img
                                className="me-2 mt-2"
                                src={creditCards}
                                alt="credit-cards"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="inputEmail4" className="form-label">
                            Expiration
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputEmail4"
                            placeholder="MM"
                          />
                        </div>
                        <div className="col-md-3 d-flex align-items-end">
                          <input
                            type="text"
                            className="form-control"
                            id="inputEmail4"
                            placeholder="YYYY"
                          />
                        </div>

                        <div className="col-md-3">
                          <label htmlFor="inputEmail4" className="form-label">
                            CVC/CVV
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputEmail4"
                            placeholder="***"
                          />
                        </div>

                        <div className="col-12 pb-3">
                          <form action="https://laderhack.vercel.app/success">
                            <button
                              onClick={(e) => {
                                handlePayment(e, orderNumber);
                              }}
                              type="submit"
                              className="btn btn-dark mt-3 py-2"
                            >
                              Pay Now
                            </button>
                          </form>
                        </div>
                      </>
                    )}
                    {showPaypal && (
                      <>
                        <Link
                          id="paypal-link"
                          to="/success"
                          className="btn btn-outline-primary text-center px-4 me-3 py-3"
                          onClick={(e) => {
                            handlePayment(e, orderNumber);
                          }}
                        >
                          <form action="https://laderhack.vercel.app/success">
                            <label htmlFor="shipping-3">
                              <img src={paypal} alt="paypal" id="paypalimg" />
                              <p className="mb-0 mt-2 fw-bold" id="paypaltxt">
                                The safer, easier way to pay
                              </p>
                            </label>
                          </form>
                        </Link>
                      </>
                    )}
                    {showMercadoPago && (
                      <>
                        <Link
                          id="mercadopago-link"
                          to="/success"
                          className="btn btn-outline-primary text-center px-4 me-3 py-3"
                          onClick={(e) => {
                            handlePayment(e, orderNumber);
                          }}
                        >
                          <form action="https://laderhack.vercel.app/success">
                            <label htmlFor="shipping-3" id="mercadoimg">
                              <img
                                id="mercadopago"
                                src={mercadopago}
                                alt="mercadopago"
                              />
                            </label>
                          </form>
                        </Link>
                      </>
                    )}
                  </form>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            {paymentCompleted && <div>Payment completed.</div>}
          </div>
          <div className="col-lg-4">
            <div className="checkout-sidebar">
              <div className="p-4 border rounded mb-40 bg-white">
                <p className="text-secondary lh-base fs-6 mb-3 text-start">
                  Apply Coupon to get discount!
                </p>
                <form className="row mb-2">
                  <div className="col-9 p-0">
                    <label
                      className="visually-hidden"
                      htmlFor="inlineFormInputGroupUsername"
                    >
                      Cupon Code
                    </label>
                    <div className="input-group ">
                      <input
                        type="text"
                        className="form-control"
                        id="inlineFormInputGroupUsername"
                        placeholder="Cupon Code"
                      />
                    </div>
                  </div>

                  <div className="col-3 p-0">
                    <button
                      onClick={notify}
                      id="apply-button"
                      type="button"
                      className="btn btn-primary w-100"
                    >
                      Apply
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="mt-45 p-3 border rounded bg-white">
              <h5 id="pricing-table">Order detail</h5>
              <div id="prices-checkout">
                {order.length > 0 &&
                  order.map((item, index) => {
                    return (
                      <>
                        <div
                          key={index}
                          className="d-flex justify-content-between pt-2"
                        >
                          <p className="text-secondary">{item.productName}:</p>
                          <p className="text-secondary">
                            $ {item.quantity * item.price}
                          </p>
                        </div>
                      </>
                    );
                  })}
              </div>

              <div id="total-payable">
                <div className="d-flex justify-content-between">
                  <p className="text-secondary">Total:</p>
                  <p className="text-secondary">$ {orderTotal}</p>
                </div>
              </div>
              <div className=" d-flex justify-content-start"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checkout;
